import { CalendarEvent } from "../models";
import { DocumentData, DocumentReference } from "@angular/fire/firestore";
import {
  ProductSharedSettingsBuilder,
  ProductAdvancedSettingsBuilder,
  ProductInventorySettingsBuilder
} from "../product/builders";

export class CalendarEventBuilder {
  public shared: ProductSharedSettingsBuilder;
  public advanced: ProductAdvancedSettingsBuilder;
  public inventory: ProductInventorySettingsBuilder;
  public reference?: DocumentReference;
  public sold: number;
  public date: Date;

  constructor() {
    this.shared = new ProductSharedSettingsBuilder();
    this.advanced = new ProductAdvancedSettingsBuilder();
    this.inventory = new ProductInventorySettingsBuilder();
  }

  build = (): CalendarEvent => new CalendarEvent(this);

  edit(event: CalendarEvent) {
    this.advanced.edit(event.advanced);
    this.shared.edit(event.shared);
    this.inventory.edit(event.inventory);
    this.date = event.date;
    this.reference = event.reference;
    this.sold = event.sold;
    return this;
  }

  load(data: DocumentData, ref: DocumentReference): CalendarEventBuilder {
    //Comes from Firebase
    this.sold = data.sold;
    this.reference = ref;
    this.date = (data.date as firebase.firestore.Timestamp).toDate();
    this.advanced.load(data.advanced);
    this.inventory.load(data.inventory);
    this.shared.load(data.shared);

    return this;
  }

  setDate(date: Date): CalendarEventBuilder {
    this.date = date;
    return this;
  }
}
